module.exports = __webpack_public_path__ + "img/marker_one_yellow3.c13982a7.png";